/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/no-children-prop */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useEffect, useState, useMemo } from 'react';
import { Formik } from 'formik';
import VersionCheck from 'react-native-version-check';
import * as Yup from 'yup';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import {
  View,
  StyleSheet,
  Dimensions,
  TouchableOpacity,
  Linking,
} from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import Toast from 'react-native-toast-message';
import {
  isWeb,
  isMobileWeb,
  isNative,
  isAndroid,
  isIos,
} from '@global/screens';
import Colors from '@global/colors';
import ModalHalf from '@components/modal/ModalHalf';
import ScrollContainer from '@components/global/ScrollContainer';
import Image from '@components/global/Image';
import Photo from '@components/global/Photo';
import SociollaText from '@components/sociolla/SociollaText';
import Input from '@components/form/Input';
import InputPassword from '@components/form/InputPassword';
import Button from '@components/form/Button';
import Toggle from '@components/form/Toggle';
import * as Layout from '@components/screen/Layout';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import MoreButton from '@components/navbar/MoreButton';
import { LinearGradient } from 'expo-linear-gradient';

import * as Auth from '@/store/auth/actions';
import { showPopup } from '@/store/modal';
import { handleUserData } from '@/store/auth/actions';
import { showAlert } from '@/store/global';

import useApi from '@/hooks/useApi';
import { MsAuth } from '@api/ms-auth';
import { MsAccount } from '@api/ms-account';
import {
  uploadS3,
  chooseImagePicker,
  hasNoAccess,
  parseDate,
  getAutoSavePhoto,
  setAutoSavePhoto,
  hasGalleryPermission,
} from '@global/helpers';
import { SALESMAN_TYPE_OBJ, VERSION, PASSWORD_REGEX } from '@/constants';
import ModalLog from '@components/modal/ModalLog';
import { USER_LOG_FORMATTER } from '@/constants/log';
import { logEvent } from '@global/analytics';

const dimension = Dimensions.get('screen');

const UserProfile = (props) => {
  const salesCodeRoles = [
    'salesman',
    'key_account_manager',
    'group_key_account_manager',
  ];
  const userData = useSelector((state) => state.auth.user);
  // eslint-disable-next-line no-unused-vars
  const userRole = userData?.role?.code;
  const insets = useSafeAreaInsets();
  const dispatch = useDispatch();
  const [profileDetail, setProfileDetail] = useState({});
  const [isDetail, setIsDetail] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isNeedUpdate, setIsNeedUpdate] = useState(false);
  const [urlUpdate, setUrlUpdate] = useState('');
  const [isActive, setIsActive] = useState(null);
  const [modalLog, setModalLog] = useState(false);
  const [isAutoSavePhoto, setIsAutoSavePhoto] = useState(true);

  const isShow = useSelector((state) => state.modal);
  const isShowChangePhoneNumber = isShow.changePhoneNumber;
  const isShowChangePassword = isShow.changePassword;
  const heightProfile = isWeb
    ? '100%'
    : isMobileWeb
    ? 'calc(100vh - 55px)'
    : dimension.height - insets.top - insets.bottom - 55 - (isAndroid ? 75 : 0);
  const hasAccess = hasNoAccess([
    'regional_manager',
    'regional_support',
    'key_account_manager',
    'group_key_account_manager',
    'distributor_manager',
    'general_manager',
    'vice_president',
    'regional_distributor_manager',
  ]);

  const getUserDetail = useApi(MsAccount.getUserDetail);
  const MobileScroll = !isWeb ? ScrollContainer : View;

  const getDetail = async (id) => {
    const response = await getUserDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      setProfileDetail(response.data.data);
      setIsActive(response.data.data.is_active);
    } else {
      setProfileDetail({});
      setIsActive(null);
    }
  };

  const FormPhoneValidationSchema = Yup.object().shape({
    phone: Yup.number()
      .typeError('Phone number must be a number')
      .max(1234567890123, 'Max 13 characters.')
      .required('Phone number is required.'),
  });

  const FormPasswordValidationSchema = Yup.object().shape({
    current_password: Yup.string().required('Current password is required.'),
    new_password: Yup.string()
      .min(8, 'Min. 8 characters.')
      .required('New password is required.')
      .matches(
        new RegExp(/^.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?].*$/),
        'New password must have at least 1 special character.',
      )
      .matches(
        new RegExp(/.*[A-Z].*/),
        'New password must have at least 1 uppercase',
      )
      .matches(
        new RegExp(PASSWORD_REGEX),
        'Password must have at least 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character (!@#$%^&*.), no spaces, and no character repeated 3+ times in a row',
      ),
    confirm_new_password: Yup.string()
      .min(8, 'Min. 8 characters.')
      .required('Confirm new password is required.')
      .oneOf([Yup.ref('new_password'), null], 'Confirm password must match.')
      .matches(
        new RegExp(/^.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?].*$/),
        'Confirm new password must have at least 1 special character.',
      )
      .matches(
        new RegExp(/.*[A-Z].*/),
        'Confirm new password must have at least 1 uppercase',
      )
      .matches(
        new RegExp(PASSWORD_REGEX),
        'Password must have at least 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character (!@#$%^&*.), no spaces, and no character repeated 3+ times in a row',
      ),
  });

  // [B2B-5968] Auto-save taken photos to the device gallery (device-local preference).
  const onToggleAutoSavePhoto = async (value) => {
    const saved = await setAutoSavePhoto(value);
    if (saved) {
      setIsAutoSavePhoto(value);
    } else if (value) {
      dispatch(
        showAlert({
          show: true,
          isModal: true,
          title: 'Permission denied',
          description:
            'You need to give permission to access your photo gallery in device settings',
          isConfirm: false,
        }),
      );
    }
  };

  const logout = async () => {
    try {
      logEvent({
        eventName: 'logout_process',
        data: {
          method: isNative ? 'apps' : 'web',
        },
        dataKey: 'detail',
      });
      await dispatch(Auth.logout());
      Toast.show({
        text1: 'You have successfully logged out',
        type: 'success',
      });
    } catch (err) {
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  };

  const chooseFile = async () => {
    const image = await chooseImagePicker(1000, false);
    if (image && image.uri) {
      dispatch(showPopup({ name: 'isLoading', value: true }));
      try {
        const url = await uploadS3({ file: image, isImage: true });
        if (url) {
          const updateData = await MsAccount.updateUser(profileDetail._id, {
            image: url,
          });
          if (updateData && updateData.data && updateData.data.data) {
            const oldUser = JSON.parse(JSON.stringify(profileDetail));
            oldUser.image = url;
            setProfileDetail(oldUser);
            dispatch(handleUserData(oldUser));
            Toast.show({ text1: 'Successfully edited data', type: 'success' });
            dispatch(showPopup({ name: 'isLoading', value: false }));
          } else {
            Toast.show({ text1: 'A system error occurred', type: 'error' });
            dispatch(showPopup({ name: 'isLoading', value: false }));
          }
        } else {
          Toast.show({ text1: 'A system error occurred', type: 'error' });
          dispatch(showPopup({ name: 'isLoading', value: false }));
        }
      } catch (error) {
        Toast.show({ text1: 'A system error occurred', type: 'error' });
        dispatch(showPopup({ name: 'isLoading', value: false }));
      }
    }
  };

  const goBack = () => {
    if (props.route.params.branchId) {
      props.navigation.navigate('BranchListNavigator', {
        screen: 'BranchListDetailScreen',
        params: {
          ...props.route.params,
          id: props.route.params.branchId,
          titleScreen: props.route.params.branchName,
          name: props.route.params.branchName,
        },
      });
    } else {
      props.navigation.navigate('UserNavigator', {
        screen: 'UsersScreen',
        params: { id: '', name: '', titleScreen: '' },
      });
    }
  };

  const changeUserState = async (data) => {
    try {
      if (profileDetail && profileDetail._id) {
        dispatch(showPopup({ name: 'isLoading', value: true }));
        const user = await MsAccount.changeUserState(profileDetail._id, {
          is_active: !profileDetail.is_active,
        });
        if (user && user.data && user.data.data) {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'Successfully updated user state',
            type: 'success',
          });
          getDetail(profileDetail._id);
        } else {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({ text1: 'Failed to update user state', type: 'error' });
        }
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  };

  const onInvite = async () => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const inviteUser = await MsAccount.inviteUser(props.route.params.id);
      if (inviteUser && inviteUser.data && inviteUser.data.data) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'Successfully invited user', type: 'success' });
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'Failed to invite user', type: 'error' });
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: error?.response?.data?.message || 'A system error occurred',
        type: 'error',
      });
    }
  };

  // const onRemove = async () => {
  //   dispatch(showPopup({ name: 'isLoading', value: true }));
  //   try {
  //     const removeUser = await MsAccount.deleteUser(props.route.params.id);
  //     if (removeUser && removeUser.data && removeUser.data.data) {
  //       dispatch(showPopup({ name: 'isLoading', value: false }));
  //       Toast.show({ text1: 'Successfully removed user', type: 'success' });
  //       props.navigation.navigate('UserNavigator', {
  //         screen: 'UsersScreen',
  //       });
  //     } else {
  //       dispatch(showPopup({ name: 'isLoading', value: false }));
  //       Toast.show({ text1: 'Failed to remove user', type: 'error' });
  //     }
  //   } catch (error) {
  //     dispatch(showPopup({ name: 'isLoading', value: false }));
  //     Toast.show({
  //       text1: error?.response?.data?.message || 'A system error occurred',
  //       type: 'error',
  //     });
  //   }
  // };

  const onUpdateVersion = () => {
    let url = '';

    if (isIos) {
      url = 'https://apps.apple.com/id/app/nina-by-semesta/id1617084671';
    } else {
      url = 'https://play.google.com/store/apps/details?id=com.semesta.nina';
    }

    if (urlUpdate) {
      url = urlUpdate;
    }

    Linking.openURL(url);
  };

  const getUpdateVersion = async () => {
    setUrlUpdate('');
    await VersionCheck.needUpdate({ country: 'id' })
      .then((response) => {
        if (response?.isNeeded == true) {
          setIsNeedUpdate(true);
          if (response?.storeUrl) {
            setUrlUpdate(response.storeUrl);
          }
        } else {
          setIsNeedUpdate(false);
        }
      })
      .catch(() => {
        setIsNeedUpdate(false);
      });
  };

  useEffect(() => {
    if (isNative) {
      // [B2B-5968] Show OFF when gallery permission was revoked in device settings, so the
      // toggle never claims photos are being saved when they aren't.
      Promise.all([getAutoSavePhoto(), hasGalleryPermission()]).then(
        ([enabled, granted]) => setIsAutoSavePhoto(enabled && granted),
      );
    }
  }, []);

  useEffect(() => {
    props.navigation.setOptions({
      headerRight: () =>
        isWeb ? (
          <NotificationSettingButton {...props} />
        ) : (
          <MoreButton
            menu={[
              {
                type: 'function',
                name: 'Edit',
                callback: () =>
                  props.navigation.navigate(
                    'UserFormScreen',
                    props.route.params,
                  ),
              },
              ...(isActive !== null
                ? [
                    {
                      type: 'function',
                      name: isActive ? 'Inactive' : 'Active',
                      callback: changeUserState,
                    },
                  ]
                : []),
              {
                type: 'function',
                name: 'Invite User',
                callback: onInvite,
              },
            ]}
          />
        ),
    });
  }, [props.navigation, isActive]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (props?.route?.params?.id) {
        setIsDetail(true);
        getDetail(props.route.params.id);
      } else {
        setIsDetail(false);
        if (userData.role?.id && userData.role?.code !== '3pl') {
          setProfileDetail(userData);
        } else {
          if (props.route?.params?.id || userData._id) {
            getDetail(props.route?.params?.id || userData._id);
          }
        }
        setIsActive(userData.is_active);
      }
      getUpdateVersion();
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  const ProfileImage = useMemo(() => {
    return (
      <>
        <View
          style={{
            width: '100%',
            ...(isWeb
              ? {
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10,
                  overflow: 'hidden',
                }
              : {}),
          }}>
          <LinearGradient
            colors={['#A8D6F2', '#A8D6F2', '#7292C9', '#38489D']}
            locations={[0.0582, 0.2137, 0.5596, 0.9179]}
            start={{ x: 1, y: 0.5 }}
            end={{ x: 0, y: 0.5 }}
            style={{ width: '100%', height: 120 }}
          />
        </View>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
            marginTop: -65,
            marginBottom: isMobileWeb ? 0 : 20,
            width: 130,
            height: 130,
            borderColor: Colors.white,
            borderWith: 5,
            ...(!isWeb
              ? {
                  alignSelf: 'center',
                  marginHorizontal: 'auto',
                }
              : { marginLeft: 25 }),
          }}>
          <Photo
            width={130}
            height={130}
            touchable={!isDetail}
            bordered={true}
            onPress={() => chooseFile()}
            image={profileDetail.image}
          />
        </View>
      </>
    );
  }, [isDetail, profileDetail]);

  const MyProfile = useMemo(() => {
    return isDetail && getUserDetail && getUserDetail.loading ? (
      <Layout.Loader />
    ) : profileDetail && Object.keys(profileDetail).length ? (
      <View
        style={[
          styles.profileContainer,
          isNative ? { height: heightProfile } : { minHeight: heightProfile },
        ]}>
        {ProfileImage}
        {isWeb && hasAccess ? (
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'flex-end',
              paddingRight: 15,
              marginTop: isDetail ? -65 : 0,
            }}>
            {isDetail ? (
              <>
                {!props.route.params.branchId ? (
                  <>
                    <Button
                      type="primary"
                      rounded={true}
                      buttonStyle={{ width: 120, marginRight: 15 }}
                      title={
                        <SociollaText
                          type="bold"
                          style={{ fontSize: 14, color: Colors.white }}>
                          EDIT
                        </SociollaText>
                      }
                      onPress={() =>
                        props.navigation.navigate('UserNavigator', {
                          screen: 'UserFormScreen',
                          params: props.route.params,
                        })
                      }
                    />
                    {/* <Button
                      type="outline-primary"
                      rounded={true}
                      buttonStyle={{ width: 100, marginRight: 15 }}
                      title={
                        <SociollaText
                          type="bold"
                          style={{ fontSize: 14, color: Colors.blue1 }}>
                          REMOVE
                        </SociollaText>
                      }
                      onPress={() => onRemove()}
                    /> */}
                  </>
                ) : (
                  false
                )}
                <Button
                  type="primary"
                  rounded={true}
                  buttonStyle={{ width: 120, backgroundColor: Colors.blue0 }}
                  title={
                    <SociollaText
                      type="bold"
                      style={{ fontSize: 14, color: Colors.white }}>
                      INVITE
                    </SociollaText>
                  }
                  onPress={() => onInvite()}
                />
              </>
            ) : (
              false
            )}
          </View>
        ) : (
          false
        )}
        <MobileScroll
          style={styles.profileScroll}
          contentContainerStyle={styles.profileScrollContent}>
          <View style={styles.profileItem}>
            <View style={styles.itemLeft}>
              <SociollaText style={{ color: Colors.grey1 }}>Name</SociollaText>
            </View>
            <View style={styles.itemRight}>
              <SociollaText style={{}}>
                {profileDetail.name ? profileDetail.name : '-'}
              </SociollaText>
            </View>
          </View>
          <View style={styles.profileItem}>
            <View style={styles.itemLeft}>
              <SociollaText style={{ color: Colors.grey1 }}>Email</SociollaText>
            </View>
            <View style={styles.itemRight}>
              <SociollaText style={{}}>
                {profileDetail.email ? profileDetail.email : '-'}
              </SociollaText>
            </View>
          </View>
          <View style={styles.profileItem}>
            <View style={styles.itemLeft}>
              <SociollaText style={{ color: Colors.grey1 }}>
                Password
              </SociollaText>
            </View>
            <View style={styles.itemRight}>
              <SociollaText style={{}}>*********</SociollaText>
              {!isDetail ? (
                <TouchableOpacity
                  activeOpacity={0.6}
                  style={{ position: 'absolute', right: 0 }}
                  onPress={() =>
                    dispatch(showPopup({ name: 'changePassword', value: true }))
                  }>
                  <SociollaText style={{ color: Colors.blue0 }}>
                    Change
                  </SociollaText>
                </TouchableOpacity>
              ) : (
                false
              )}
            </View>
          </View>
          <View style={styles.profileItem}>
            <View style={styles.itemLeft}>
              <SociollaText style={{ color: Colors.grey1 }}>
                Phone Number
              </SociollaText>
            </View>
            <View style={styles.itemRight}>
              <SociollaText style={{}}>
                {profileDetail.phone ? profileDetail.phone : ''}
              </SociollaText>
              {!isDetail ? (
                <TouchableOpacity
                  activeOpacity={0.6}
                  style={{ position: 'absolute', right: 0 }}
                  onPress={() =>
                    dispatch(
                      showPopup({ name: 'changePhoneNumber', value: true }),
                    )
                  }>
                  <SociollaText style={{ color: Colors.blue0 }}>
                    Change
                  </SociollaText>
                </TouchableOpacity>
              ) : (
                false
              )}
            </View>
          </View>
          {profileDetail &&
          profileDetail.country &&
          profileDetail.country.length ? (
            <View style={styles.profileItem}>
              <View style={styles.itemLeft}>
                <SociollaText style={{ color: Colors.grey1 }}>
                  Country
                </SociollaText>
              </View>
              <View style={styles.itemRight}>
                <SociollaText>{profileDetail.country.join(', ')}</SociollaText>
              </View>
            </View>
          ) : (
            <View style={styles.profileItem}>
              <View style={styles.itemLeft}>
                <SociollaText style={{ color: Colors.grey1 }}>
                  Country
                </SociollaText>
              </View>
              <View style={styles.itemRight}>
                <SociollaText style={{}}>-</SociollaText>
              </View>
            </View>
          )}
          <View style={styles.profileItem}>
            <View style={styles.itemLeft}>
              <SociollaText style={{ color: Colors.grey1 }}>Role</SociollaText>
            </View>
            <View style={styles.itemRight}>
              <SociollaText style={{}}>
                {profileDetail.role && profileDetail.role.name
                  ? profileDetail.role.name
                  : '-'}
              </SociollaText>
            </View>
          </View>
          {isDetail ? (
            <View style={styles.profileItem}>
              <View style={styles.itemLeft}>
                <SociollaText style={{ color: Colors.grey1 }}>
                  Status
                </SociollaText>
              </View>
              <View
                style={[
                  styles.itemRight,
                  { flexDirection: 'row', alignItems: 'center' },
                ]}>
                <View
                  style={{
                    backgroundColor: profileDetail.is_active
                      ? '#d4edda'
                      : '#f8d7da',
                    paddingVertical: 4,
                    paddingHorizontal: 12,
                    borderRadius: 4,
                  }}>
                  <SociollaText
                    style={{
                      fontSize: 12,
                      color: profileDetail.is_active ? '#155724' : '#721c24',
                    }}>
                    {profileDetail.is_active ? 'Active' : 'Inactive'}
                  </SociollaText>
                </View>
                <TouchableOpacity
                  testID="user-profile-see-log-btn"
                  onPress={() => setModalLog(true)}>
                  <SociollaText
                    style={{
                      fontSize: 12,
                      color: Colors.blue0,
                      marginLeft: 20,
                    }}>
                    see log
                  </SociollaText>
                </TouchableOpacity>
              </View>
            </View>
          ) : (
            false
          )}
          {profileDetail &&
          profileDetail.branch &&
          profileDetail.branch.length ? (
            <View style={styles.profileItem}>
              <View style={styles.itemLeft}>
                <SociollaText style={{ color: Colors.grey1 }}>
                  Branch
                </SociollaText>
              </View>
              <View style={styles.itemRight}>
                <SociollaText>
                  {profileDetail.branch
                    .filter((a) => a.name)
                    .map((item) => item.name)
                    .join(', ')}
                </SociollaText>
              </View>
            </View>
          ) : (
            false
          )}
          {profileDetail &&
          profileDetail.sales_team &&
          profileDetail.sales_team.length &&
          Array.isArray(profileDetail.sales_team) ? (
            <View style={styles.profileItem}>
              <View style={styles.itemLeft}>
                <SociollaText style={{ color: Colors.grey1 }}>
                  Sales Team
                </SociollaText>
              </View>
              <View style={styles.itemRight}>
                <SociollaText>
                  {profileDetail.sales_team
                    .filter((a) => a.name)
                    .map((item) => item.name)
                    .join(', ')}
                </SociollaText>
              </View>
            </View>
          ) : (
            false
          )}
          {salesCodeRoles.includes(profileDetail?.role?.code) ? (
            <>
              <View style={styles.profileItem}>
                <View style={styles.itemLeft}>
                  <SociollaText style={{ color: Colors.grey1 }}>
                    Sales Code
                  </SociollaText>
                </View>
                <View style={styles.itemRight}>
                  <SociollaText style={{}}>
                    {profileDetail.sales_code ? profileDetail.sales_code : '-'}
                  </SociollaText>
                </View>
              </View>
              {profileDetail?.role?.code == 'salesman' ? (
                <View style={styles.profileItem}>
                  <View style={styles.itemLeft}>
                    <SociollaText style={{ color: Colors.grey1 }}>
                      Salesman Type
                    </SociollaText>
                  </View>
                  <View style={styles.itemRight}>
                    <SociollaText>
                      {profileDetail.salesman_type &&
                      SALESMAN_TYPE_OBJ[profileDetail.salesman_type]
                        ? SALESMAN_TYPE_OBJ[profileDetail.salesman_type]
                        : '-'}
                    </SociollaText>
                  </View>
                </View>
              ) : (
                false
              )}
            </>
          ) : (
            false
          )}
          {profileDetail?.role?.code == '3pl' ? (
            <>
              <View style={styles.profileItem}>
                <View style={styles.itemLeft}>
                  <SociollaText style={{ color: Colors.grey1 }}>
                    Carrier
                  </SociollaText>
                </View>
                <View style={styles.itemRight}>
                  <SociollaText style={{}}>
                    {profileDetail?.carrier?.name
                      ? profileDetail?.carrier?.name
                      : '-'}
                  </SociollaText>
                </View>
              </View>
            </>
          ) : (
            false
          )}
          {isNative ? (
            <View style={[styles.profileItem, styles.profileItemVersion]}>
              <View
                style={[
                  styles.itemLeft,
                  !isNeedUpdate ? styles.itemLeftUpToDate : {},
                ]}>
                <SociollaText style={{ color: Colors.grey1 }}>
                  Version: {VERSION}
                </SociollaText>
                {!isNeedUpdate ? (
                  <SociollaText
                    style={{ color: Colors.grey1, fontSize: 12, marginTop: 5 }}>
                    You're on latest version
                  </SociollaText>
                ) : (
                  false
                )}
              </View>
              <View style={[styles.itemRight, styles.itemRightVersion]}>
                {isNeedUpdate ? (
                  <TouchableOpacity
                    activeOpacity={0.8}
                    onPress={() => onUpdateVersion()}>
                    <SociollaText style={styles.itemRightUpdate}>
                      Update now!
                    </SociollaText>
                  </TouchableOpacity>
                ) : (
                  false
                )}
              </View>
            </View>
          ) : (
            false
          )}
          {isNative && !isDetail ? (
            <View style={styles.profileItem}>
              <View style={styles.itemLeft}>
                <SociollaText style={{ color: Colors.grey1 }}>
                  Auto-save photos
                </SociollaText>
                <SociollaText
                  style={{ color: Colors.grey1, fontSize: 12, marginTop: 5 }}>
                  Save photos taken in the app to your gallery
                </SociollaText>
              </View>
              <View style={[styles.itemRight, styles.itemRightVersion]}>
                <Toggle
                  size="small"
                  value={isAutoSavePhoto}
                  onValueChange={onToggleAutoSavePhoto}
                />
              </View>
            </View>
          ) : (
            false
          )}
          <View style={styles.profileItem}>
            <View style={styles.itemLeft}>
              <SociollaText style={{ color: Colors.grey1 }}>
                Last Login
              </SociollaText>
            </View>
            <View style={styles.itemRight}>
              <SociollaText style={{}}>
                {profileDetail.last_login
                  ? parseDate(profileDetail.last_login, 'dd/MM/yyyy')
                  : '-'}
              </SociollaText>
            </View>
          </View>
        </MobileScroll>
        {!isDetail ? (
          <View
            style={[
              styles.bottomContainer,
              isMobileWeb
                ? {
                    position: 'fixed',
                    bottom: 0,
                    right: 0,
                    left: 0,
                    zIndex: 10,
                    paddingBottom: 'env(safe-area-inset-bottom, 0px)',
                  }
                : {
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    left: 0,
                  },
            ]}>
            <View style={styles.bottomWrapper}>
              <TouchableOpacity
                activeOpacity={0.6}
                style={styles.bottomBtn}
                onPress={() => logout()}>
                <Image
                  style={{ width: 22, height: 20 }}
                  width={22}
                  height={20}
                  svg={true}
                  source={require('@assets/img/icons/logout.svg')}
                />
                <SociollaText style={{ fontSize: 14, marginLeft: 15 }}>
                  Log Out
                </SociollaText>
              </TouchableOpacity>
              {/* <TouchableOpacity
                  activeOpacity={.6}
                  style={styles.bottomBtn}
                  onPress={() => dispatch(showPopup({name:'changePassword',value:true}))}
              >
                  <SociollaText style={{fontSize:14,marginRight:15,color:Colors.blue2}}>Change Password</SociollaText>
              </TouchableOpacity> */}
            </View>
          </View>
        ) : (
          false
        )}
      </View>
    ) : (
      <View style={{ padding: 15 }}>
        <SociollaText style={{ color: Colors.grey1 }}>
          User not found.
        </SociollaText>
      </View>
    );
  }, [
    isNative,
    isMobileWeb,
    VERSION,
    isDetail,
    getUserDetail,
    heightProfile,
    profileDetail,
    hasAccess,
    SALESMAN_TYPE_OBJ,
  ]);

  const ProfileContainer = useMemo(() => {
    return isWeb ? (
      <>
        <Layout.Back
          title={
            isDetail ? props.route.params.branchName || 'Users' : 'My Profile'
          }
          single={!isDetail}
          onCallback={() => goBack()}
        />
        <Layout.Wrapper rounded>{MyProfile}</Layout.Wrapper>
      </>
    ) : (
      MyProfile
    );
  }, [
    isDetail,
    getUserDetail,
    heightProfile,
    profileDetail,
    hasAccess,
    SALESMAN_TYPE_OBJ,
  ]);

  return (
    <Layout.Container>
      {ProfileContainer}
      <ModalHalf
        title="Change Phone Number"
        visible={isShowChangePhoneNumber}
        maxWidth={isWeb ? 400 : '100%'}
        onClose={() =>
          dispatch(showPopup({ name: 'changePhoneNumber', value: false }))
        }
        children={
          <Formik
            initialValues={{
              phone: '',
            }}
            validationSchema={FormPhoneValidationSchema}
            onSubmit={async (payload) => {
              setIsLoadingSubmit(true);
              try {
                const updatePhone = await MsAccount.updateUser(
                  profileDetail._id,
                  payload,
                );
                if (updatePhone && updatePhone.data && updatePhone.data.data) {
                  const newUserData = JSON.parse(JSON.stringify(profileDetail));
                  newUserData.phone = payload.phone;
                  setIsLoadingSubmit(false);
                  dispatch(handleUserData(newUserData));
                  setProfileDetail(newUserData);
                  Toast.show({
                    text1: 'Phone Number Changed',
                    type: 'success',
                  });
                  dispatch(
                    showPopup({ name: 'changePhoneNumber', value: false }),
                  );
                } else {
                  setIsLoadingSubmit(false);
                  Toast.show({
                    text1: 'A system error occurred',
                    type: 'error',
                  });
                }
              } catch (error) {
                setIsLoadingSubmit(false);
                Toast.show({
                  text1:
                    error?.response?.data?.message || 'A system error occurred',
                  type: 'error',
                });
              }
            }}>
            {({ setFieldValue, handleSubmit, errors, touched, values }) => (
              <View style={{ paddingTop: 15 }}>
                <View style={{ paddingHorizontal: 15, paddingBottom: 15 }}>
                  <Input
                    label="New Phone Number"
                    value={values.phone}
                    keyboardType="numeric"
                    isNumeric={true}
                    isRequired={true}
                    placeholder=""
                    maxLength={13}
                    hasError={
                      errors.phone && touched.phone ? errors.phone : null
                    }
                    onChangeText={(val) => setFieldValue('phone', val)}
                  />
                </View>
                <View
                  style={{
                    paddingVertical: 15,
                    paddingHorizontal: 15,
                    borderTopWidth: 1,
                    borderTopColor: isWeb ? 'transparent' : Colors.grey0,
                  }}>
                  <Button
                    rounded={true}
                    buttonStyle={{ width: '100%' }}
                    disabledStyle={{ width: '100%' }}
                    disabled={isLoadingSubmit || !values.phone}
                    title={
                      <SociollaText
                        type="bold"
                        style={{ fontSize: 14, color: Colors.white }}>
                        {isLoadingSubmit ? 'LOADING' : 'SAVE'}
                      </SociollaText>
                    }
                    onPress={handleSubmit}
                  />
                </View>
              </View>
            )}
          </Formik>
        }
      />
      <ModalHalf
        title="Change Password"
        visible={isShowChangePassword}
        maxWidth={isWeb ? 400 : '100%'}
        onClose={() =>
          dispatch(showPopup({ name: 'changePassword', value: false }))
        }
        children={
          <Formik
            initialValues={{
              current_password: '',
              new_password: '',
              confirm_new_password: '',
            }}
            validationSchema={FormPasswordValidationSchema}
            onSubmit={async (payload) => {
              setIsLoadingSubmit(true);
              try {
                const updatePassword = await MsAuth.changePassword(payload);
                if (
                  updatePassword &&
                  updatePassword.data &&
                  updatePassword.data.data
                ) {
                  Toast.show({
                    text1: 'Password Changed',
                    type: 'success',
                  });
                  setIsLoadingSubmit(false);
                  dispatch(showPopup({ name: 'changePassword', value: false }));
                } else {
                  Toast.show({
                    text1: 'A system error occurred',
                    type: 'error',
                  });
                  setIsLoadingSubmit(false);
                }
              } catch (error) {
                Toast.show({
                  text1:
                    error?.response?.data?.message || 'A system error occurred',
                  type: 'error',
                  props: {
                    style: {
                      maxWidth: '100%',
                    },
                  },
                });
                setIsLoadingSubmit(false);
              }
            }}>
            {({ setFieldValue, handleSubmit, errors, touched, values }) => (
              <View style={{ paddingTop: 15 }}>
                <View style={{ paddingHorizontal: 15, paddingBottom: 15 }}>
                  <InputPassword
                    label="Current Password"
                    value={values.current_password}
                    isRequired={true}
                    placeholder=""
                    hasError={
                      errors.current_password && touched.current_password
                        ? errors.current_password
                        : null
                    }
                    onChangeText={(val) =>
                      setFieldValue('current_password', val)
                    }
                  />
                  <InputPassword
                    label="New Password"
                    value={values.new_password}
                    isRequired={true}
                    placeholder=""
                    hasError={
                      errors.new_password && touched.new_password
                        ? errors.new_password
                        : null
                    }
                    onChangeText={(val) => setFieldValue('new_password', val)}
                  />
                  <InputPassword
                    label="Confirm New Password"
                    value={values.confirm_new_password}
                    isRequired={true}
                    placeholder=""
                    hasError={
                      errors.confirm_new_password &&
                      touched.confirm_new_password
                        ? errors.confirm_new_password
                        : null
                    }
                    onChangeText={(val) =>
                      setFieldValue('confirm_new_password', val)
                    }
                  />
                </View>
                <View
                  style={{
                    paddingVertical: 15,
                    paddingHorizontal: 15,
                    borderTopWidth: 1,
                    borderTopColor: isWeb ? 'transparent' : Colors.grey0,
                  }}>
                  <Button
                    rounded={true}
                    buttonStyle={{ width: '100%' }}
                    disabledStyle={{ width: '100%' }}
                    disabled={
                      isLoadingSubmit ||
                      !(
                        values.current_password &&
                        values.new_password &&
                        values.confirm_new_password
                      )
                    }
                    title={
                      <SociollaText
                        type="bold"
                        style={{ fontSize: 14, color: Colors.white }}>
                        {isLoadingSubmit ? 'LOADING' : 'SAVE'}
                      </SociollaText>
                    }
                    onPress={handleSubmit}
                  />
                </View>
              </View>
            )}
          </Formik>
        }
      />
      {modalLog && (
        <ModalLog
          testID="user-profile-modal-log"
          show={modalLog}
          status={profileDetail?.is_active ? 'active' : 'inactive'}
          data={profileDetail}
          onClose={() => setModalLog(false)}
          logType="user"
          logId={profileDetail?._id}
          logLabel="User"
          logFormatter={USER_LOG_FORMATTER}
        />
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  profileContainer: {
    width: '100%',
    paddingBottom: isWeb ? 50 : isMobileWeb ? 70 : 100,
    position: 'relative',
    ...(isMobileWeb ? { flex: 1 } : {}),
  },
  profileScroll: {
    padding: 15,
    ...(isMobileWeb ? { flex: 1, maxHeight: 360 } : {}),
  },
  profileScrollContent: {
    flexGrow: 1,
    paddingBottom: 16,
  },
  profileItem: {
    width: '100%',
    paddingVertical: 14,
    flexDirection: 'row',
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
  profileItemVersion: {
    borderBottomWidth: 0,
    paddingTop: 25,
  },
  itemLeft: { width: 130 },
  itemLeftUpToDate: { width: 200 },
  itemRight: {
    position: 'relative',
    width: !isNative ? 'calc(100% - 130px)' : dimension.width - 160,
  },
  itemRightVersion: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  itemRightUpdate: {
    color: Colors.blue0,
  },
  bottomContainer: {
    borderTopColor: Colors.grey0,
    borderTopWidth: 1,
    backgroundColor: Colors.white,
  },
  bottomWrapper: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  bottomBtn: {
    paddingHorizontal: 15,
    paddingVertical: 20,
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export default UserProfile;
